import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Box, Stack, Heading, StepLine, Step, ActionButton } = designSystem;

const WizardSetupStepsPanel = ({ captions, steps, isDesktopView, onStepButtonClick }) => (
  <div className="ws-wizard-setup-steps-panel">
    <Box
      {...(isDesktopView
        ? {
            padding: 'spacing-xl',
            paddingTop: 'spacing-3-xl',
            paddingRight: 'spacing-3-xl',
          }
        : {
            padding: 'spacing-xs',
            paddingTop: 'spacing-3-xs',
            paddingBottom: 'spacing-m',
          })}
    >
      <Stack gap="spacing-m">
        <Stack gap="spacing-3-xs">
          <Heading type="heading-3">{captions.title}</Heading>
        </Stack>
        <StepLine orientation={isDesktopView ? 'vertical' : 'horizontal'} gap="spacing-2-xs">
          {steps.map(
            ({ id, marker, active, passed, completed, invalid, disabled, isInteractive }) => (
              <Step
                key={id}
                marker={marker}
                active={active}
                passed={passed}
                completed={completed}
                invalid={invalid}
                disabled={disabled}
                {...(!isDesktopView && {
                  label: captions.steps[id],
                  onClick: isInteractive ? () => onStepButtonClick(id) : null,
                })}
              >
                {isDesktopView && (
                  <div>
                    {isInteractive ? (
                      <ActionButton
                        format="text"
                        disabled={disabled}
                        label={captions.steps[id]}
                        onClick={() => onStepButtonClick(id)}
                      />
                    ) : (
                      <Heading type="heading-6" {...(disabled && { appearance: 'low-emphasis' })}>
                        {captions.steps[id]}
                      </Heading>
                    )}
                  </div>
                )}
              </Step>
            )
          )}
        </StepLine>
      </Stack>
    </Box>
  </div>
);

WizardSetupStepsPanel.propTypes = {
  captions: PropTypes.shape().isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      marker: PropTypes.number.isRequired,
      active: PropTypes.bool.isRequired,
      passed: PropTypes.bool.isRequired,
      completed: PropTypes.bool.isRequired,
    })
  ).isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  onStepButtonClick: PropTypes.func.isRequired,
};

export default WizardSetupStepsPanel;
